import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react' 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, SelectBox } from 'devextreme-react';
import { productRecipeService } from '../services/product-recipe-service';
import { productPortfolioService } from '../services/product-portfolio-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import ProductRecipeSubList from './product-recipe-sub-list';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { confirm } from 'devextreme/ui/dialog';

const ProductRecipe = () => {

    const [productRecipe] = useState<any>(
        {
            receiptProductCode: null, recipeDetails: null
        }
    );

    let ProductCode: any;
    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["receiptProductCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        if (ProductCode) {
            const x = await productRecipeService.getOrderList(ProductCode);
            return x;
        }
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const [productLookups] = useState(new CustomStore({
        load: productPortfolioService.getProductsLookup
    }));

    const [productValue, setProductValue] = useState("");
    const onValueChangedProduct = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        ProductCode = e.value;
        setProductValue(e.value)
    }, []);

    const [popupVisibleOrders, setPopupVisibleOrders] = useState(false);
    const showInfoOrders = useCallback((e: any) => {
        setPopupVisibleOrders(true);
    }, [setPopupVisibleOrders]);

    const hideInfoOrders = useCallback(() => {
        setPopupVisibleOrders(false);
    }, [setPopupVisibleOrders]);

    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();
    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["productCode"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])

    const onGetVendorSummaries = useCallback(async () => {
        return await productRecipeService.getAddOrDetailList(ProductCode);
    }, []);

    const onAdd = async () => {
        dgVendorSummaryRef.current?.instance.refresh().then(x => showInfoOrders(0));
    }

    const [retailerStore] = useState(() => createCustomStore({
        key: 'code',
        load: productPortfolioService.getProductsLookup,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["code", "=", key];
            }
        },
    }));

    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if ((e.column.dataField === 'productCode' || e.column.dataField === 'productQty')) {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };

    // const newProductRow: any = {};
    // const handleInitNewRow = async (e: any) => {
    //     newProductRow.productUnitCode="kg";
    //     e.data = newProductRow;
    // };



    // const onSave = async () => {
    //     if (dgVendorSummaryRef.current?.instance.hasEditData()) {
    //         let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
    //         result.then((dialogResult) => {
    //             if (dialogResult) {
    //                 dgVendorSummaryRef.current?.instance.saveEditData();
    //             }
    //         });
    //     }
    // }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            productRecipe.receiptProductCode = productValue;
            productRecipe.recipeDetails = e.changes;
            productRecipeService.saveee(productRecipe).then((response) => {
                dgVendorSummaryRef.current?.instance.refresh().then(x => dgVendorSummaryRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_add")}
                        type="default"
                        icon="add"
                        onClick={onAdd}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6 required"> {t("syncflow:lb_product")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="productLookups"
                                dataSource={productLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedProduct}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef  }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={false}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                    }}
                    masterDetail={ProductRecipeSubList}
                    columns={[
                        {
                            dataField: 'receiptProductCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'receiptProductName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'receiptPrice',
                            caption: "Receipt Price",
                            allowFiltering: true,
                            allowEditing: true,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'costAmount',
                            caption: "Cost Amount",
                            allowFiltering: true,
                            allowEditing: true,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        }
                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisibleOrders}
                onHiding={hideInfoOrders}
                title="Order products list"
                showTitle={true}
                width={1200}
                height={740}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                {/* <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_save")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={onSave}
                        />
                    </div>
                </div> */}
                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={false}
                    headerFilterVisible={false}
                    keyboardNavigation={true}
                    excellExport={false}
                    onFocusedCellChanging={onFocusedCellChanging}
                    onCellPrepared={onCellPrepared}
                    onSaving={onSaving}
                    // onInitNewRow={handleInitNewRow}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: true,
                        allowDeleting: false,
                        allowUpdating: true,
                    }}
                    columns={[
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_name'),
                            filtering: false,
                            allowSearch: false,
                            allowEditing: true,
                            lookup: {
                                dataSource: retailerStore,
                                valueExpr: "code",
                                displayExpr: "name"
                            },
                        },
                        {
                            dataField: 'productQty',
                            caption: t('syncflow:lb_qty'),
                            filtering: false,
                            allowSearch: false,
                            allowEditing: true,
                            dataType: 'number',
                        },
                        {
                            dataField: 'productUnitCode',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            filtering: false,
                            allowSearch: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'costPrice',
                            caption: "Cost Price",
                            filtering: false,
                            allowSearch: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'costAmaount',
                            caption: "Cost Amount",
                            filtering: false,
                            allowSearch: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        }
                    ]}
                />
            </Popup>

        </>


    )
}
export default ProductRecipe